import { render, staticRenderFns } from "./unitEntryByPkb.vue?vue&type=template&id=37970684&scoped=true"
import script from "./unitEntryByPkb.vue?vue&type=script&lang=js"
export * from "./unitEntryByPkb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37970684",
  null
  
)

export default component.exports